import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { publicApi } from "@/lib/api";

const FALLBACK_TESTIMONIALS = [
  {
    comment:
      "MHJ moved my 911 from Birmingham down to a buyer in Brighton. Photos at both ends, on time, zero fuss. Easy 10/10.",
    display_name: "James W.",
    route: "Porsche owner · Birmingham",
    rating: 5,
  },
  {
    comment:
      "Broke down on the A38 at midnight. They were with me in under an hour and dropped the car at my home address. Lifesavers.",
    display_name: "Hannah P.",
    route: "Private customer · Derby",
    rating: 5,
  },
  {
    comment:
      "We use MHJ for trade movements weekly. Reliable, communicative and they actually answer the phone — rare in this game.",
    display_name: "Marcus D.",
    route: "Dealership Principal · Stoke",
    rating: 5,
  },
];

export default function Testimonials() {
  const [items, setItems] = useState(FALLBACK_TESTIMONIALS);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await publicApi.get("/reviews/featured?limit=6");
        if (cancelled) return;
        if (Array.isArray(data) && data.length > 0) {
          setItems(data);
          setLive(true);
        }
      } catch (_) {
        // silent — keep fallback
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
          <span className="w-8 h-px bg-[#E60000]" />
          {live ? "Verified reviews · 05" : "Words · 05"}
        </div>
        <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.0] max-w-3xl">
          Trusted by drivers,
          <br />
          <span className="text-zinc-500">dealers and insurers.</span>
        </h2>

        <div
          className={`grid grid-cols-1 ${items.length >= 2 ? "md:grid-cols-2" : ""} ${items.length >= 3 ? "lg:grid-cols-3" : ""} gap-px bg-white/10 border border-white/10 mt-16`}
        >
          {items.slice(0, 6).map((t, i) => (
            <figure
              key={t.review_id || i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0A0A0A] p-8 lg:p-10 flex flex-col gap-6"
            >
              <div className="flex items-center justify-between">
                <Quote className="w-8 h-8 text-[#E60000]" strokeWidth={1.5} />
                {t.rating > 0 && (
                  <div className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <Star
                        key={j}
                        className={`w-3.5 h-3.5 ${j < t.rating ? "text-[#E60000] fill-[#E60000]" : "text-zinc-800"}`}
                      />
                    ))}
                  </div>
                )}
              </div>
              <blockquote className="text-white text-lg lg:text-xl leading-snug font-medium">
                &ldquo;{t.comment}&rdquo;
              </blockquote>
              <figcaption className="mt-auto pt-6 border-t border-white/10">
                <div className="text-white text-sm font-bold">{t.display_name}</div>
                {t.route && <div className="text-zinc-500 text-xs mt-1">{t.route}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
